query Report($id: ID!) {
  report(id: $id) {
    id
    type
    widget
    status
    progress
    rowCount
    fileName
    error {
      code
      message
    }
    createdAt
    completedAt
    expiresAt
  }
}
